import { type FC } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { ErrorIcon } from "@snapchat/snap-design-system-icons";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { type MyLensesSubmissionError } from "../../../../gql-generated/types";

import {
    LensSubmissionErrorMessageItemBody,
    LensSubmissionErrorMessageItemContainer,
    LensSubmissionErrorMessageItemContent,
    LensSubmissionErrorMessageItemTitle,
    WarningSection,
} from "./LensSubmissionErrorMessageItem.styles";

export const LensSubmissionErrorMessageItem: FC<MyLensesSubmissionError> = ({ heading, message }) => {
    return (
        <LensSubmissionErrorMessageItemContainer>
            <LensSubmissionErrorMessageItemContent flexDirection="column">
                <LensSubmissionErrorMessageItemTitle>{heading}</LensSubmissionErrorMessageItemTitle>
                <LensSubmissionErrorMessageItemBody>
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{message}</ReactMarkdown>
                </LensSubmissionErrorMessageItemBody>
            </LensSubmissionErrorMessageItemContent>
            <WarningSection>
                <ErrorIcon fill={Colors.Red.V150} />
            </WarningSection>
        </LensSubmissionErrorMessageItemContainer>
    );
};
